import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_stabbed-by-steve/artifacts/0igyj2n2_logonewred.png" 
              alt="StabbedBySteve Logo" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-zinc-400 leading-relaxed">
              Professional body piercing with precision, safety, and style. All jewelry included.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-zinc-100 mb-4 uppercase tracking-wide">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/gallery" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/aftercare" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Aftercare
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Book Appointment
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-zinc-100 mb-4 uppercase tracking-wide">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-zinc-400">
                <Mail className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>info@stabbedabysteve.com</span>
              </li>
              <li className="flex items-start gap-3 text-zinc-400">
                <Phone className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>562-245-8889</span>
              </li>
              <li className="flex items-start gap-3 text-zinc-400">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>123 Main Street<br />Your City, ST 12345</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-8 pt-8 text-center text-zinc-500 text-sm">
          <p>&copy; {new Date().getFullYear()} StabbedBySteve.com. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;